import _ from 'lodash';
import qs from 'qs';
import debounce from 'throttle-debounce/debounce';
import Decimal from 'decimal.js';

import frontEndVars from '~/front-end-vars';
import { addAfterPasteEvent } from '~/common';
import { formatPrice } from '~common/index';
import $ from '~/qwery';
import bean from '~/bean';
import axios from '~/axios';
import Button from '~/components/button';
import Validation from '~/components/validation';
import popupManager from '~/components/popup/manager';
import Popup from '~/components/popup/popup';

export default class BasketPopup extends Popup {
    constructor(data, options = {}) {
        super({noInit: true});
        this.init(Object.assign({
            class: 'basket-popup group',
            title: 'Корзина',
            content:
                '<div class="b-basket-popup-content">'
                    + '<%= html %>'
                + '</div>',
            templateVars: {
                html: data.html,
            },
            deliveryFee: options['deliveryFee'] || 0,
            afterRenderTemplate: () => {
                this.$content = $('.b-basket-popup-content', this.$el);
                this.$basePriceRow = $('.base-price-row', this.$content);
                this.$basePrice = $('.base-price', this.$content);
                this.$discountRow = $('.discount-row', this.$content);
                this.$discount = $('.discount', this.$content);
                this.$deliveryRow = $('.delivery-row', this.$content);
                this.$deliveryFee = $('.delivery-fee', this.$content);
                this.$total = $('.total', this.$content);
                this.updateTotals(data.items);
            },
            buttons: Object.assign(
                {okButton: options['okButton']
                    ? Object.assign({
                        onPress: () => {
                            this.destroy();
                            return false;
                        },
                    }, options['okButton'])
                    : {
                        role: 'link',
                        label: 'Оформити замовлення',
                        onPress: () => {
                            if ( ! this._validation.validate()) {
                                return false;
                            }
                            location = $(document.body).data('order-url');
                            return false;
                        },
                    }},
                options['noCancelButton'] ? {} : {cancelButton: {
                    role: 'button',
                    label: 'Продовжити покупки',
                    onPress: () => this.destroy(),
                }},
            ),
            afterShow: () => {
                $('tr .item-link', this.$content)[0].focus();
            },
        }, options));

        $('.delete-button', this.$content).each(b => {
            new Button(b);
        });

        this._validation = new Validation(this.$content);

        bean.on(this.$content[0], 'press', '.delete-button', e => {
            const button = new Button(e.target);
            if (button.disabled())
                return;
            button.disabled(true);
            popupManager.markEnterAsHandled(e.detail.initialEvent);
            const product_id = $(e.target).parent('tr').data('product-id');
            const size_id = $(e.target).parent('tr').data('size-id') || null;
            axios.delete('/basket', {
                data: qs.stringify({
                    product_id,
                    size_id,
                }),
            }).then(resp => {
                if ($('tr', this.$content).length > 2) {
                    this.updateTotals(resp.data.items);
                    $(e.target).parent('tr').remove();
                } else
                    this.destroy();
                if (this.options('onChange'))
                    this.options('onChange')(resp.data,
                        this.totals(resp.data.items));
                button.disabled(false);
            });
        });

        addAfterPasteEvent(this.$content[0]);
        bean.on(this.$content[0], 'keydown change afterpaste', '.amount-cell input',
            debounce(250, e => {
                const product_id = $(e.target).parent('tr').data('product-id');
                const size_id = $(e.target).parent('tr').data('size-id') || null;
                const amount = e.target.value;
                const i = data['items'].find(i =>
                    i['product_id'] == product_id && i['size_id'] == size_id
                );
                if (amount == i['amount'])
                    return;
                if ( ! this._validation.validate())
                    return;
                axios.patch('/basket', qs.stringify({
                    product_id: product_id,
                    size_id: size_id,
                    amount: amount,
                })).then(resp => {
                    i['amount'] = amount;
                    this.updateTotals(resp.data.items);
                    if (this.options('onChange'))
                        this.options('onChange')(resp.data,
                            this.totals(resp.data.items));
                });
            }));
    }

    updateTotals(items) {
        const totals = this.totals(items);
        this.$basePriceRow[
            totals['discount'] || this.options('deliveryFee') ? 'removeClass' : 'addClass'
        ]('hidden');
        this.$basePrice.text(formatPrice(totals['basePrice']));
        this.$discountRow[
            totals['discount'] ? 'removeClass' : 'addClass'
        ]('hidden');
        this.$discount.text(formatPrice( - totals['discount']));
        this.$deliveryRow[
            this.options('deliveryFee') ? 'removeClass' : 'addClass'
        ]('hidden');
        this.$deliveryFee.text(formatPrice(this.options('deliveryFee')));
        this.$total.text(formatPrice(
            totals['basePrice'] - totals['discount'] + this.options('deliveryFee')
        ));
    }

    totals(items) {
        const basePrice = this.basePrice(items);
        return {
            basePrice,
            discount: this.discount(basePrice),
        };
    }

    basePrice(items) {
        return _.sum(items.map(i => i.price * i.amount ));
    }

    discount(basePrice) {
        return basePrice >= frontEndVars.DISCOUNT_THRESHOLD ?
            new Decimal(basePrice).mul(frontEndVars.DISCOUNT).round()
        : 0;
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/popup/basket-popup.js